import "core-theme/normalize";
import { datadogRum } from "@datadog/browser-rum";
import { initializeRum, initializeLogs, logger } from "@hopper-b2b/datadog";
import { serviceWorker } from "@hopper-b2b/portal";
import { ClientName } from "@hopper-b2b/types";
import { DesktopMobileFrame } from "@hsbc/portal";
import { createRoot } from "react-dom/client";
import { v4 as uuidv4 } from "uuid";
import config, { environmentConfig } from "../config";
import { App } from "./App";
const sessionIdKey = "sessionId";
const sessionId = sessionStorage.getItem(sessionIdKey)
  ? sessionStorage.getItem(sessionIdKey)
  : uuidv4();
sessionStorage.setItem(sessionIdKey, sessionId);
const storeDomain = "hsbc.com";

initializeLogs({
  service: `Portal-FE-${ClientName.HSBC_QA}`,
  env: config.bootConfig.env,
  sessionId,
  version: environmentConfig.version,
  forwardErrorsToLogs: true,
});

setTimeout(() => {
  initializeRum({
    enableSessionRecording: true,
    service: ClientName.HSBC_QA,
    env: config.bootConfig.env,
    version: environmentConfig.version,
    allowedTracingUrls: [
      "http://localhost:3003",
      "https://hsbc-qa.eng.app-development.h4r.io/",
      "https://hsbc-qa.staging.hopper.com/",
      "https://hsbc-qa.hopper.com/",
      "https://travel.hsbc.ae",
    ],
  });
}, 1000);

setTimeout(() => {
  logger().info(`DD RUM: ${JSON.stringify(datadogRum.getInternalContext())}`);
}, 2000);

// Riskified
const riskifiedScript = document.createElement("script");
riskifiedScript.src =
  ("https:" === document.location.protocol ? "https://" : "http://") +
  "beacon.riskified.com?shop=" +
  storeDomain +
  "&sid=" +
  sessionId;
riskifiedScript.async = true;
riskifiedScript.type = "text/javascript";
document.head.appendChild(riskifiedScript);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <DesktopMobileFrame>
    <App />
  </DesktopMobileFrame>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
